import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type FulfillmentTrackingUpdateWithinState = string;

export const FULFILLMENT_TRACKING_UPDATE_WITHIN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>
  >,
): ConditionType<
  FulfillmentTrackingUpdateWithinState,
  Condition.FulfillmentTrackingUpdateWithin
> => ({
  name: "Time since last tracking update",
  description(numDays) {
    return `Within ${numDays} days of last tracking update`;
  },
  Details(
    props: ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>,
  ) {
    return React.createElement(Details, props);
  },
  empty: (30).toFixed(0),
  fromModel(model) {
    return model.duration.total("days").toFixed(0);
  },
  toModel(state) {
    return {
      type: Condition.FULFILLMENT_TRACKING_UPDATE_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return +state >= 0 && +state % 1 === 0; // Must be whole number
  },
});
